export const expectedMonthlyExpenses = [
  {
    id: 'LESS_THAN_10_000',
    label: '0 - 10 000',
  },
  {
    id: 'BTW_10_000_AND_50_000',
    label: '10 001 - 50 000',
  },
  {
    id: 'BTW_50_000_AND_250_000',
    label: '50 001 - 250 000',
  },
  {
    id: 'MORE_THAN_250_000',
    label: '250 001 - *',
  },
];
